import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  pages: [],
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.NAVIGATION__LOADED_PAGE_NAVIGATION:
    case AppConstants.NAVIGATION__LOADED_EXTERNAL_PAGE_NAVIGATION:
      return {...state, pages: action.payload.pages};
    default:
      return state;
  }
};
